var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(" 这里管的是审核通过"),
            _c("b", [_vm._v("之后")]),
            _vm._v(
              "的淘客：查推广人数与收益、停用与恢复。待审核的申请在「淘客申请」页。 停用只影响"
            ),
            _c("b", [_vm._v("停用之后支付成功")]),
            _vm._v("的订单，在途分润照常结算，推广关系保留不动。 "),
          ]),
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidthSm",
                      attrs: { clearable: "" },
                      on: {
                        change: function ($event) {
                          return _vm.load(1)
                        },
                      },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "在职", value: 1 } }),
                      _c("el-option", { attrs: { label: "已停用", value: 0 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "姓名/手机号" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: { clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.load(1)
                      },
                    },
                    model: {
                      value: _vm.query.keyword,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "keyword", $$v)
                      },
                      expression: "query.keyword",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.load(1)
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.reset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.list, size: "small", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              false
                ? _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", width: "70" },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: "淘客", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", [_vm._v(_vm._s(row.realName || "—"))]),
                        _c("div", { staticClass: "sub-line" }, [
                          _vm._v("uid " + _vm._s(row.uid)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "手机号", width: "130" },
              }),
              _c("el-table-column", {
                attrs: { label: "当前绑定上级", "min-width": "230" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.boundUpline && row.boundUpline.status === "BOUND"
                          ? _c("div", [
                              _c("div", [
                                _vm._v(
                                  _vm._s(row.boundUpline.name || "用户") +
                                    "（UID " +
                                    _vm._s(row.boundUpline.uid) +
                                    "）"
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  "推广码：" +
                                    _vm._s(row.boundUpline.promoCode || "暂无")
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  "绑定时间：" +
                                    _vm._s(row.boundUpline.bindTime || "未记录")
                                ),
                              ]),
                            ])
                          : _c("div", [
                              _vm._v(
                                _vm._s(
                                  !row.boundUpline
                                    ? "绑定信息暂不可用"
                                    : row.boundUpline.status === "PENDING"
                                    ? "尚未确认上级"
                                    : row.boundUpline.status === "INACTIVE"
                                    ? "关系已解除"
                                    : "未绑定上级"
                                )
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "idCardNo",
                  label: "身份证号",
                  "min-width": "170",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "promoCode", label: "推广码", width: "110" },
              }),
              _c("el-table-column", {
                attrs: { label: "推广人数", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(row.memberCount || 0))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "累计收益", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.yuan(row.totalAmount)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type:
                                row.status === 1
                                  ? "success"
                                  : row.status === 2
                                  ? "warning"
                                  : "info",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  row.status === 1
                                    ? "在职"
                                    : row.status === 2
                                    ? "待签约"
                                    : "已停用"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "时间", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "sub-line" }, [
                          _vm._v("生效 " + _vm._s(row.enableTime || "—")),
                        ]),
                        row.disableTime
                          ? _c("div", { staticClass: "sub-line" }, [
                              _vm._v("停用 " + _vm._s(row.disableTime)),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "110", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.status === 1
                          ? _c(
                              "el-button",
                              {
                                staticClass: "danger-text",
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setStatus(row, false)
                                  },
                                },
                              },
                              [_vm._v("停用")]
                            )
                          : row.status !== 2
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setStatus(row, true)
                                  },
                                },
                              },
                              [_vm._v("恢复")]
                            )
                          : _c("span", { staticClass: "sub-line" }, [
                              _vm._v("待平台上传合同"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pager" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.query.size,
                  "current-page": _vm.query.page,
                  total: _vm.total,
                },
                on: { "size-change": _vm.onSize, "current-change": _vm.load },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }